<template v-if="saleDetails">
  <div class="container">
    <p class="text-center pt-4">***START OF FISCAL RECEIPT***</p>
    <div class="receipt p-1">
      <p class="text-center">
        {{ business.name ? business.name : business.taxprNm }}
        <br />{{ business.sctrNm + ", " + business.dstrtNm }} <br />{{
          business.prvncNm
        }}, Kenya <br />PIN: {{ business.pin }}
      </p>

      <h5 class="text-center my-3 fw-bold">TAX INVOICE</h5>

      <div class="text-center">
        Buyer Name:{{ saleDetails.custNm ? saleDetails.custNm : "N/A" }}
      </div>
      <div class="pb-2 text-center">
        Buyer PIN: {{ saleDetails.custTin ? saleDetails.custTin : "N/A" }}
      </div>

      <div class="line"></div>
      <table class="table table-borderless table-sm mt-2">
        <thead>
          <tr>
            <th>Item Description</th>
            <th>Qty</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="item in saleDetails.items" :key="item.id">
            <tr>
              <td colspan="3">{{ item.itemNm + " " + item.taxTyCd }}</td>
            </tr>

            <tr>
              <td>{{ formatToMoney(item.prc) }}</td>
              <td>{{ item.qty }}</td>
              <td>{{ formatToMoney(item.totAmt) + " - " + item.taxTyCd }}</td>
            </tr>
          </template>
        </tbody>
      </table>

      <div class="line"></div>
      <p class="fw-bold">
        Sub Total: {{ formatToMoney(saleDetails.totTaxblAmt) }} <br />VAT:
        {{ formatToMoney(saleDetails.totTaxAmt) }} <br />
        TOTAL: {{ formatToMoney(saleDetails.totAmt) }} <br />
      </p>

      <div class="line"></div>
      <div>CASH: {{ formatToMoney(saleDetails.totAmt) }}</div>
      <div class="mb-2">ITEMS NUMBER: {{ saleDetails.totItemCnt }}</div>

      <div class="line"></div>
      <table class="table table-borderless table-sm border-white">
        <thead>
          <tr>
            <th>Rate</th>
            <th>Taxable Amt</th>
            <th>VAT</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>A - EX</td>
            <td>{{ formatToMoney(saleDetails.taxblAmtA) }}</td>
            <td>{{ formatToMoney(saleDetails.taxAmtA) }}</td>
          </tr>
          <tr>
            <td>B - 16%</td>
            <td>{{ formatToMoney(saleDetails.taxblAmtB) }}</td>
            <td>{{ formatToMoney(saleDetails.taxAmtB) }}</td>
          </tr>
          <tr>
            <td>C - 0%</td>
            <td>{{ formatToMoney(saleDetails.taxblAmtC) }}</td>
            <td>{{ formatToMoney(saleDetails.taxAmtC) }}</td>
          </tr>
          <tr>
            <td>D - Non-VAT</td>
            <td>{{ formatToMoney(saleDetails.taxblAmtD) }}</td>
            <td>{{ formatToMoney(saleDetails.taxAmtD) }}</td>
          </tr>
          <tr>
            <td>E - 8%</td>
            <td>{{ formatToMoney(saleDetails.taxblAmtE) }}</td>
            <td>{{ formatToMoney(saleDetails.taxAmtE) }}</td>
          </tr>
        </tbody>
      </table>

      <div class="line"></div>
      <div class="mt-2">
        <strong>SCU INFORMATION</strong>
        <p>
          DATE: {{ date }} <br />
          SCU ID: {{ business.sdcId }} <br />
          CU INVOICE NO: {{ business.sdcId }}/{{ saleDetails.invcNo }} <br />
          INTERNAL DATA: {{ saleDetails.intrlData }} <br />
          RECEIPT SIGNATURE: {{ saleDetails.rcptSign }}
        </p>
      </div>
      <div>
        <qrcode-vue
          :value="qrCodeData"
          :size="108"
          class="qrcode mb-4 d-block"
        ></qrcode-vue>
      </div>

      <div class="line"></div>

      <div class="mt-2">
        <strong>TIS INFORMATION</strong>
        <p>
          Print Receipt No: {{ saleDetails.invcNo }} <br />DATE:
          {{ date }} TIME: {{ time }}
        </p>
      </div>

      <p class="text-center pt-1 pb-2">***END OF FISCAL RECEIPT***</p>

      <p class="ps-text">
        Powered by Taxpoint
        <br />
        Taxpoint eTIMS POS
        <br />
        0792855169
        <br />
        info@ubuniworks.com
      </p>
    </div>
  </div>
</template>

<script setup>
import QrcodeVue from "qrcode.vue";
import { useMakeSaleStore } from "../stores/SaleStore.js";
import { ref, watchEffect } from "vue";

const qrCodeData = ref("");

const useSaleStore = useMakeSaleStore();

const saleDetails = ref(useSaleStore.saleDetails);
const business = ref(useSaleStore.business);

const date = ref("");
const time = ref("");

const formatToMoney = (value) => {
  const formattedValue = Number(value).toFixed(2);
  return formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

watchEffect(() => {
  const today = new Date();
  date.value =
    today.getFullYear() +
    "-" +
    (today.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    today.getDate().toString().padStart(2, "0");

  time.value =
    today.getHours() +
    ":" +
    today.getMinutes().toString().padStart(2, "0") +
    ":" +
    today.getSeconds().toString().padStart(2, "0");

  saleDetails.value = useSaleStore.saleDetails;
  business.value = useSaleStore.business;
  qrCodeData.value = saleDetails.value.qrurl;
});
</script>

<style scoped>
* {
  font-family: Arial, sans-serif !important;
  color: black !important;
  background-color: white;
  font-size: 0.9rem !important;
}

.receipt {
  max-width: 80mm;
  margin: auto;
}

.ps-text {
  font-size: 0.8rem !important;
  line-height: 1.2rem !important;
}

td,
th {
  padding: 0 !important;
  background-color: white !important;
  text-transform: capitalize;
}

.line {
  border-top: 1px solid black;
}
</style>
